<div style="display: block; width: 100%">
    <div id="" class="page-layout simple right-sidebar" fxLayout="row">
        <div class="center" fusePerfectScrollbar>
            <div
                class="header accent p-24 pb-0"
                fxLayout="column"
                fxLayoutAlign="space-between"
            >
                <div fxLayout="row" fxLayoutAlign="space-between start">
                    <span
                        class="mat-display-1 my-0 my-sm-24 welcome-message"
                        [@animate]="{ value: '*', params: { x: '50px' } }"
                        >Home
                    </span>
                </div>
            </div>
        </div>
    </div>

    <mat-tab-group
        style="width: 100%"
        (selectedTabChange)="onTabChange($event)"
        [selectedIndex]="selectedIndex"
    >
        <!--map view tab 1-->
        <mat-tab label="Map View" *ngIf="dyanmicMapView">
            <ng-template matTabContent>
                <mat-card fxLayout="row" fxLayoutAlign="end center" class="p-8">
                    <div fxFlex="5" *ngIf="localStorage.role_code != 'END'">
                        <button
                            mat-mini-fab
                            color="primary"
                            (click)="openFilterBox()"
                            matTooltip="Filter Data"
                        >
                            <mat-icon>filter_alt</mat-icon>
                        </button>
                    </div>
                </mat-card>
                <div class="filter-box-wrapper" *ngIf="filterBox">
                    <mat-card
                        class="filter-box p-8"
                        *ngIf="localStorage.role_code != 'END'"
                    >
                        <mat-card-header>
                            <mat-card-title class="mb-0">Filter</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <div
                                id="forms"
                                class="page-layout simple fullwidth"
                                fxLayout="column"
                            >
                                <form
                                    [formGroup]="formCCS"
                                    class="mat-card mat-elevation-z4 p-15"
                                    fxLayout="column"
                                    fxLayoutAlign="start"
                                    fxFlex="1 0 auto"
                                    name="form"
                                    style="padding-bottom: 0px"
                                >
                                    <div
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        fxLayoutGap="25px"
                                        fxFlex="1 0 auto"
                                    >
                                        <mat-form-field
                                            appearance="outline"
                                            fxFlex="50"
                                        >
                                            <mat-label>Select Client</mat-label>
                                            <input
                                                type="text"
                                                matInput
                                                formControlName="charClient"
                                                [matAutocomplete]="autoClient"
                                            />
                                            <mat-autocomplete
                                                #autoClient="matAutocomplete"
                                                [displayWith]="
                                                    displayCharClient
                                                "
                                                (optionSelected)="
                                                    onClientChange(
                                                        $event.option.value
                                                            .client_id
                                                    )
                                                "
                                            >
                                                <mat-option
                                                    *ngFor="
                                                        let option of filteredOptionsCharClient
                                                            | async
                                                    "
                                                    [value]="option"
                                                >
                                                    {{ option.client_name }}
                                                </mat-option>
                                            </mat-autocomplete>
                                            <mat-icon
                                                matSuffix
                                                class="secondary-text"
                                                matTooltip="Please select client"
                                                >expand_more
                                            </mat-icon>
                                            <mat-error
                                                *ngIf="
                                                    formCCS.get('charClient')
                                                        .invalid
                                                "
                                            >
                                                Please select client
                                            </mat-error>
                                        </mat-form-field>
                                        <mat-form-field
                                            appearance="outline"
                                            fxFlex="50"
                                        >
                                            <mat-label>Select CPO's</mat-label>
                                            <input
                                                type="text"
                                                matInput
                                                formControlName="charCPO"
                                                [matAutocomplete]="auto1"
                                            />
                                            <mat-autocomplete
                                                #auto1="matAutocomplete"
                                                [displayWith]="displayCharCPO"
                                                (optionSelected)="
                                                    onCPOChange(
                                                        $event.option.value
                                                            .cpo_id
                                                    )
                                                "
                                            >
                                                <mat-option
                                                    *ngFor="
                                                        let option of filteredOptionsCharCPO
                                                            | async
                                                    "
                                                    [value]="option"
                                                >
                                                    {{ option.cpo_name }}
                                                </mat-option>
                                            </mat-autocomplete>
                                            <mat-icon
                                                matSuffix
                                                class="secondary-text"
                                                matTooltip="Please select CPO"
                                                >expand_more
                                            </mat-icon>
                                            <mat-error
                                                *ngIf="
                                                    formCCS.get('charCPO')
                                                        .invalid
                                                "
                                            >
                                                Please select CPO
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        fxLayoutGap="25px"
                                        fxFlex="1 0 auto"
                                    >
                                        <mat-form-field
                                            appearance="outline"
                                            fxFlex="50"
                                        >
                                            <mat-label
                                                >Select Charging
                                                Station</mat-label
                                            >
                                            <input
                                                type="text"
                                                matInput
                                                formControlName="charStat"
                                                [matAutocomplete]="auto2"
                                            />
                                            <mat-autocomplete
                                                #auto2="matAutocomplete"
                                                [displayWith]="displayCharStat"
                                                (optionSelected)="
                                                    onStationChange(
                                                        $event.option.value
                                                            .station_id
                                                    )
                                                "
                                            >
                                                <mat-option
                                                    *ngFor="
                                                        let option of filteredOptionsCharStat
                                                            | async
                                                    "
                                                    [value]="option"
                                                >
                                                    {{ option.station_name }}
                                                </mat-option>
                                            </mat-autocomplete>
                                            <mat-icon
                                                matSuffix
                                                class="secondary-text"
                                                matTooltip="Please select charging station"
                                            >
                                                expand_more</mat-icon
                                            >
                                            <mat-error
                                                *ngIf="
                                                    formCCS.get('charStat')
                                                        .invalid
                                                "
                                            >
                                                Please select charging station
                                            </mat-error>
                                        </mat-form-field>
                                        <div fxFlex="50"></div>
                                    </div>
                                </form>
                            </div>
                        </mat-card-content>
                        <mat-card-footer class="m-0">
                            <div class="p-15">
                                <div fxLayout="row" fxLayoutAlign="end center">
                                    <button
                                        mat-raised-button
                                        color="warn"
                                        type="button"
                                        class="mr-8 my-0"
                                        (click)="openFilterBox()"
                                    >
                                        Cancel
                                    </button>
                                    <!-- <button mat-raised-button type="button" color="warn" class="mr-8" (click)="close()">Cancel</button> -->
                                </div>
                            </div>
                        </mat-card-footer>
                    </mat-card>
                </div>
                <mat-card>
                    <mat-card-content>
                        <div id="wrapper">
                            <div id="google_map" class="map_border">
                                <agm-map
                                    [zoom]="zoom"
                                    [latitude]="lat"
                                    [longitude]="lng"
                                    [fullscreenControl]="true"
                                    [gestureHandling]="cooperative"
                                    (mapReady)="mapReady($event)"
                                    (mapClick)="close_infoWinow($event)"
                                    [scrollwheel]="null"
                                >
                                    <button
                                        id="Settings"
                                        class="controls"
                                        style="
                                            margin-top: 10px;
                                            margin-right: 10px;
                                        "
                                        mat-mini-fab
                                        color="primary"
                                        (click)="actionDialog()"
                                    >
                                        <mat-icon aria-hidden="true"
                                            >battery_charging_full</mat-icon
                                        >
                                    </button>
                                    <!-- <button id="Profile" class="controls" style="margin-top:10px;margin-right:10px" mat-mini-fab color="primary" (click)="batteryDialog()">
                <mat-icon aria-hidden="true">power</mat-icon>
              </button> -->
                                    <!--button id="Settings" class="toggle-button controls button" [hidden]="hideSettings" >
                 <mat-icon aria-hidden="true">battery_charging_full</mat-icon>
              </button-->
                                    <!--button id="Profile" class="toogle-button controls button" (click)="actionDialog($event)">
                <mat-icon aria-hidden="true">account_circle</mat-icon>
              </button-->

                                    <div
                                        id="actiondiv"
                                        class="controls"
                                        appOutside
                                        (clickedOutside)="closeEvent()"
                                    >
                                        <div
                                            class="actionpanel fullwidth"
                                            fxLayout="column"
                                        >
                                            <mat-icon
                                                id="icon_action_div"
                                                matTooltip="Close window"
                                                (click)="closeActionPanel()"
                                                style="
                                                    cursor: pointer;
                                                    color: #00acc1;
                                                "
                                                >clear</mat-icon
                                            >

                                            <div
                                                class="card"
                                                style="padding-top: 20px"
                                            >
                                                <div class="headerType">
                                                    <span
                                                        style="
                                                            padding-left: 10px;
                                                            padding-top: 10px;
                                                        "
                                                        >Charging Station
                                                        Type</span
                                                    >
                                                </div>
                                                <ul>
                                                    <li
                                                        *ngFor="
                                                            let item of chStationTypes;
                                                            let i = index
                                                        "
                                                        (click)="
                                                            onChStationSelect(
                                                                item
                                                            )
                                                        "
                                                    >
                                                        <a
                                                            [class.active]="
                                                                item ===
                                                                activeChStation
                                                            "
                                                        >
                                                            <div class="icon">
                                                                <mat-icon
                                                                    style="
                                                                        font-size: 32px;
                                                                        height: 32px;
                                                                        width: 32px;
                                                                    "
                                                                    >{{
                                                                        item.icon
                                                                    }}</mat-icon
                                                                >
                                                            </div>
                                                            <div class="name">
                                                                {{ item.name }}
                                                            </div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <!-- <div class="card ">
                        <div class="headerType">
                          <span style="padding-left: 10px;padding-top: 10px;">Vehicle Type</span>
                        </div>
                        <ul>
                          <li *ngFor="let item of vehicleTypes; let i=index" 
                                (click)="onVehicleSelect(item)">
                                <a  [class.active]="item === activeState">
                                  <div class="icon">
                                      <mat-icon style="font-size: 32px;height: 32px;
                                      width: 32px;">{{item.icon}}</mat-icon>
                                  </div>
                                  <div class="name">{{item.name}}</div>
                                </a>
                            </li>
                        </ul>
                        </div> -->
                                            <div
                                                fxLayout="row"
                                                fxLayoutAlign="start center"
                                                fxLayoutGap="20px"
                                                fxFlex="1 0 auto"
                                            >
                                                <mat-form-field
                                                    appearance="outline"
                                                    fxFlex="50"
                                                    class="pr-4"
                                                >
                                                    <mat-label
                                                        >By Station
                                                        Name</mat-label
                                                    >
                                                    <input
                                                        matInput
                                                        id=""
                                                        [ngModelOptions]="{
                                                            standalone: true
                                                        }"
                                                        autocomplete="new-password"
                                                        [(ngModel)]="
                                                            chStationSearch
                                                        "
                                                        (ngModelChange)="
                                                            stationChange(
                                                                $event
                                                            )
                                                        "
                                                        type="search"
                                                    />
                                                </mat-form-field>
                                                <div
                                                    *ngIf="
                                                        filterdStationOptions.length &&
                                                        show
                                                    "
                                                    (click)="clear() && hide()"
                                                    class="stock-search-result"
                                                >
                                                    <div
                                                        *ngFor="
                                                            let station of filterdStationOptions
                                                        "
                                                        class="search-result-item"
                                                        (click)="
                                                            locationStation(
                                                                station
                                                            )
                                                        "
                                                    >
                                                        <div
                                                            class="search-result-name"
                                                        >
                                                            {{ station.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <mat-form-field
                                                    appearance="outline"
                                                    fxFlex="50"
                                                    class="pr-4"
                                                >
                                                    <mat-label
                                                        >By Connector
                                                        Type</mat-label
                                                    >
                                                    <mat-select
                                                        [ngModelOptions]="{
                                                            standalone: true
                                                        }"
                                                        [(ngModel)]="
                                                            connectorSearch
                                                        "
                                                        required
                                                    >
                                                        <mat-option
                                                            *ngFor="
                                                                let connector of connectorTypes
                                                            "
                                                            [value]="
                                                                connector.id
                                                            "
                                                        >
                                                            {{ connector.name }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div
                                                class="card"
                                                style="padding-top: 20px"
                                            >
                                                <form
                                                    [formGroup]="form"
                                                    class="form-field-full"
                                                >
                                                    <div
                                                        fxLayout="row"
                                                        fxLayoutAlign="start center"
                                                        fxLayoutGap="20px"
                                                        fxFlex="1 0 auto"
                                                    >
                                                        <mat-form-field
                                                            appearance="outline"
                                                            fxFlex="50"
                                                            class="pr-4"
                                                        >
                                                            <mat-label
                                                                >By City
                                                            </mat-label>
                                                            <input
                                                                matInput
                                                                id=""
                                                                [ngModelOptions]="{
                                                                    standalone: true
                                                                }"
                                                                autocomplete="new-password"
                                                                [(ngModel)]="
                                                                    cityOptionSearch
                                                                "
                                                                (ngModelChange)="
                                                                    cityChange(
                                                                        $event
                                                                    )
                                                                "
                                                                type="citySearch"
                                                            />
                                                            <mat-icon
                                                                matSuffix
                                                                class="secondary-text"
                                                                >expand_more</mat-icon
                                                            >
                                                        </mat-form-field>
                                                        <div
                                                            *ngIf="
                                                                filterdCityOptions.length &&
                                                                cityShow
                                                            "
                                                            (click)="
                                                                cityClear() &&
                                                                    cityHide()
                                                            "
                                                            class="city-search-result"
                                                        >
                                                            <div
                                                                *ngFor="
                                                                    let city of filterdCityOptions
                                                                "
                                                                class="search-result-item"
                                                                (click)="
                                                                    cityPick(
                                                                        city
                                                                    )
                                                                "
                                                            >
                                                                <div
                                                                    class="search-result-name"
                                                                >
                                                                    {{
                                                                        city.name
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <mat-form-field
                                                            appearance="outline"
                                                            fxFlex="50"
                                                            class="pr-4"
                                                        >
                                                            <mat-label
                                                                >Circle
                                                                Radius(Km)</mat-label
                                                            >
                                                            <input
                                                                matInput
                                                                id=""
                                                                [ngModelOptions]="{
                                                                    standalone: true
                                                                }"
                                                                autocomplete="new-password"
                                                                [(ngModel)]="
                                                                    radiusSearch
                                                                "
                                                                (ngModelChange)="
                                                                    radiusChange(
                                                                        $event
                                                                    )
                                                                "
                                                                type="select"
                                                            />
                                                        </mat-form-field>
                                                        <!-- <mat-form-field  appearance="outline" fxFlex="50" class="pr-4">
                                <mat-label>By Name</mat-label>
                                <input type="text" matInput formControlName="chStation" autocomplete="new-password"  [matAutocomplete]="auto1">
                                <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayCharger">
                                  <mat-option *ngFor="let option of filteredOptionsChStation | async" [value]="option">
                                    {{option.name}}
                                  </mat-option>
                                </mat-autocomplete>

                              </mat-form-field> -->

                                                        <!-- <div fxFlex="100" style="font-size:14px;color:black">
                        <mat-label>By </mat-label>&nbsp;&nbsp;
                        <mat-radio-group aria-label="Select an option">
                          <mat-radio-button value="1">Connector Types</mat-radio-button>&nbsp;&nbsp;
                          <mat-radio-button value="2">Rattings</mat-radio-button>&nbsp;&nbsp;
                          <mat-radio-button value="3">Favourite Location</mat-radio-button>
                        </mat-radio-group>
                      </div> -->
                                                    </div>
                                                </form>
                                                <div
                                                    style="
                                                        text-align: end;
                                                        padding-top: 20px;
                                                    "
                                                >
                                                    <button
                                                        mat-raised-button
                                                        color="accent"
                                                        (click)="searchFilter()"
                                                    >
                                                        <mat-icon
                                                            >search</mat-icon
                                                        >
                                                        Search
                                                    </button>
                                                    <!-- <button mat-raised-button color="accent"  (click)="resetAll()">
                            <mat-icon>clear_all</mat-icon>
                            Clear All
                          </button> -->
                                                    <!--button mat-mini-fab color="primary" matTooltip="Clear all"  (click)="resetAll()"aria-label="Example icon button with a filter list icon">
                        <mat-icon>clear_all</mat-icon>
                      </button-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        id="swappingDiv"
                                        class="controls"
                                        appOutside
                                        (clickedOutside)="closeEvent()"
                                    >
                                        <div class="divSwapPanel">
                                            <div class="card">
                                                <div class="headerType">
                                                    <p
                                                        style="
                                                            font-size: 14px;
                                                            margin: 0px;
                                                        "
                                                    >
                                                        Battery Swapping
                                                        Outlet<br />
                                                        Status
                                                    </p>
                                                </div>
                                                <mat-divider></mat-divider>
                                                <div class="info-Massage">
                                                    <span
                                                        class="slot-bg-green"
                                                    ></span>
                                                    <p class="indicator_name">
                                                        Available
                                                    </p>
                                                </div>
                                                <mat-divider></mat-divider>
                                                <div class="info-Massage">
                                                    <span
                                                        class="slot-bg-orange"
                                                    ></span>
                                                    <p class="indicator_name">
                                                        No Battery Available
                                                    </p>
                                                </div>
                                                <mat-divider></mat-divider>
                                                <div class="info-Massage">
                                                    <span
                                                        class="slot-bg-yellow"
                                                    ></span>
                                                    <p class="indicator_name">
                                                        Deactivated
                                                    </p>
                                                </div>
                                                <mat-divider></mat-divider>
                                                <div class="info-Massage">
                                                    <span
                                                        class="slot-bg-gray"
                                                    ></span>
                                                    <p class="indicator_name">
                                                        Not Connected
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--button id="Logout" class="toggle-button controls button" (click)="logout()">Logout</button-->
                                    <agm-circle
                                        [latitude]="lat"
                                        [longitude]="lng"
                                        [radius]="circleMapRadius"
                                        [editable]="false"
                                        [strokeColor]="'#000'"
                                        [strokeWeight]="'3px'"
                                        (radiusChange)="
                                            circleMapRadiusChange($event)
                                        "
                                    >
                                    </agm-circle>

                                    <agm-marker
                                        id="infowindow"
                                        *ngFor="
                                            let m of stationMarker;
                                            let i = index
                                        "
                                        (markerClick)="clickedMarker(m)"
                                        [latitude]="m.lat"
                                        [longitude]="m.lng"
                                        (dragEnd)="markerDragEnd(m, $event)"
                                        [iconUrl]="
                                            m.status == 'Y'
                                                ? 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
                                                : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
                                        "
                                    >
                                        <!-- *ngFor="let m of markers; let i = index"
                   (markerClick)="clickedMarker(m.label, i,m.id)"
                   [latitude]="m.lat"
                   [longitude]="m.lng"
                   [label]="m.label"
                   [markerDraggable]="m.draggable"
                   (dragEnd)="markerDragEnd(m, $event)"> -->
                                        <!-- [iconUrl]="(m.status=='OPEN' || m.status=='CLOSE' ) ? 'assets/img/markerIconA.png' : 'assets/img/markerIconI.png'" -->
                                        <!-- <agm-circle [latitude]="lat + 0.3" [longitude]="lng" 
               [radius]="radius"
               [fillColor]="'forestgreen'"
               [circleDraggable]="false"
               [editable]="false">
           </agm-circle> -->

                                        <agm-info-window
                                            [disableAutoPan]="false"
                                            #infoWindow
                                            [isOpen]="isInfoWindowOpen(m.id)"
                                            [latitude]="m.lat"
                                            [longitude]="m.lng"
                                            style="padding: 0px"
                                        >
                                            <div
                                                *ngIf="
                                                    m.infoWindowShow;
                                                    else infoWindowTemp
                                                "
                                            ></div>
                                        </agm-info-window>
                                        <agm-direction
                                            [origin]="origin"
                                            [destination]="destination"
                                            [renderOptions]="renderOptions"
                                        >
                                        </agm-direction>
                                    </agm-marker>
                                </agm-map>
                                <ng-template #infoWindowTemp>
                                    <div class="card">
                                        <div
                                            class="section-hero-header-title-description"
                                        >
                                            <mat-icon
                                                id="icon"
                                                matTooltip="Close window"
                                                (click)="close_infoWinow()"
                                                style="
                                                    cursor: pointer;
                                                    color: white;
                                                "
                                                >clear</mat-icon
                                            >
                                            <div
                                                fxLayout="row wrap"
                                                fxLayoutGap="0px grid"
                                                class="tab-content"
                                                style="align-items: center"
                                            >
                                                <div
                                                    fxFlex="50"
                                                    fxFlex.lt-sm="100"
                                                >
                                                    <div class="station_name">
                                                        {{ infoMarker?.name }}
                                                    </div>
                                                    <div
                                                        class="station_address"
                                                    >
                                                        {{ infoMarker?.email }}
                                                    </div>
                                                    <div
                                                        class="station_address"
                                                    >
                                                        {{ infoMarker?.mobile }}
                                                    </div>
                                                </div>
                                                <div
                                                    fxFlex="50"
                                                    fxFlex.lt-sm="100"
                                                    style="
                                                        text-align: end;
                                                        padding-right: 20px;
                                                    "
                                                >
                                                    <mat-icon
                                                        matTooltip="View details"
                                                        (click)="
                                                            viewDetails(
                                                                infoMarker
                                                            )
                                                        "
                                                        style="
                                                            cursor: pointer;
                                                            color: white;
                                                        "
                                                        >preview</mat-icon
                                                    >
                                                </div>
                                            </div>
                                            <div
                                                fxLayout="row wrap"
                                                *ngIf="ameniteExits"
                                                fxLayoutGap="0px grid"
                                                class="tab-content"
                                                style="align-items: center"
                                            >
                                                <div
                                                    fxFlex="100"
                                                    fxFlex.lt-sm="100"
                                                    style="
                                                        text-align: end;
                                                        padding-right: 20px;
                                                    "
                                                >
                                                    <div class="chipicon">
                                                        <img
                                                            *ngFor="
                                                                let amenite of infoMarker?.amenities;
                                                                let i = index
                                                            "
                                                            src="{{
                                                                amenite.icon_url
                                                            }}"
                                                            width="24px"
                                                            height="24px;"
                                                            matTooltip="{{
                                                                amenite.amenity_name
                                                            }}"
                                                            style="
                                                                margin-right: 5px;
                                                            "
                                                            class="emenite_icon"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <mat-tab-group>
                                            <mat-tab label="Station Details">
                                                <div
                                                    fxLayout="row wrap"
                                                    fxLayoutGap="0px grid"
                                                    class="tab-content"
                                                >
                                                    <div
                                                        fxFlex="50"
                                                        fxFlex.lt-sm="100"
                                                    >
                                                        <div class="label_txt">
                                                            <span
                                                                class="material-icons icon-middle"
                                                                >person_pin</span
                                                            >
                                                            {{
                                                                infoMarker?.cp_name
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div
                                                        fxFlex="50"
                                                        fxFlex.lt-sm="100"
                                                    >
                                                        <div class="label_txt">
                                                            <span
                                                                class="material-icons icon-middle"
                                                                >person_pin</span
                                                            >
                                                            {{
                                                                infoMarker?.cpo_name
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div
                                                        fxFlex="50"
                                                        fxFlex.lt-sm="100"
                                                    >
                                                        <div class="label_txt">
                                                            <span
                                                                class="material-icons icon-middle"
                                                                >ev_station</span
                                                            >
                                                            Location Type:
                                                            {{
                                                                infoMarker?.location_type
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div
                                                        fxFlex="50"
                                                        fxFlex.lt-sm="100"
                                                    >
                                                        <div class="label_txt">
                                                            <span
                                                                class="material-icons icon-middle"
                                                                >location_on</span
                                                            >
                                                            Commissioned Date:
                                                            {{
                                                                infoMarker?.commissioned_dt
                                                                    | date
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div
                                                        fxFlex="50"
                                                        fxFlex.lt-sm="100"
                                                    >
                                                        <div class="label_txt">
                                                            <span
                                                                class="material-icons icon-middle"
                                                                >call</span
                                                            >
                                                            Register As:
                                                            {{
                                                                infoMarker?.register_as
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div
                                                        fxFlex="50"
                                                        fxFlex.lt-sm="100"
                                                    >
                                                        <div class="label_txt">
                                                            <span
                                                                class="material-icons icon-middle"
                                                                >ev_station</span
                                                            >
                                                            Electricity line :
                                                            {{
                                                                infoMarker?.electricity_line
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </mat-tab>
                                            <mat-tab label="Charger Details">
                                                <div class="tab-content">
                                                    <div
                                                        class="charger-head"
                                                    ></div>
                                                    <div>
                                                        <mat-accordion
                                                            class="example-headers-align"
                                                        >
                                                            <mat-expansion-panel
                                                                *ngFor="
                                                                    let charger of chargers;
                                                                    let i = index
                                                                "
                                                                (opened)="
                                                                    setOpened(i)
                                                                "
                                                                (closed)="
                                                                    setClosed(i)
                                                                "
                                                                style="
                                                                    width: 590px;
                                                                "
                                                            >
                                                                <mat-expansion-panel-header>
                                                                    <mat-panel-title>
                                                                        {{
                                                                            charger?.serial_no
                                                                        }}
                                                                    </mat-panel-title>
                                                                    <mat-panel-description>
                                                                        {{
                                                                            charger?.charger_batch_name
                                                                        }}
                                                                        <div
                                                                            *ngIf="
                                                                                charger.charger_status ==
                                                                                'ONLINE'
                                                                            "
                                                                        >
                                                                            <mat-icon
                                                                                [ngStyle]="{
                                                                                    color: 'green'
                                                                                }"
                                                                                matTooltip="Charger Online"
                                                                                >public </mat-icon
                                                                            >&nbsp;&nbsp;
                                                                            <mat-icon
                                                                                [ngStyle]="{
                                                                                    color: 'green'
                                                                                }"
                                                                                matTooltip="Book now"
                                                                                (click)="
                                                                                    bookings(
                                                                                        charger
                                                                                    )
                                                                                "
                                                                                >menu_book</mat-icon
                                                                            >
                                                                        </div>
                                                                        <div
                                                                            *ngIf="
                                                                                charger.charger_status ==
                                                                                'OFFLINE/UNAVALIABLE'
                                                                            "
                                                                        >
                                                                            <mat-icon
                                                                                [ngStyle]="{
                                                                                    color: 'red'
                                                                                }"
                                                                                matTooltip="Charger Offline"
                                                                                >public_off
                                                                            </mat-icon>
                                                                        </div>
                                                                    </mat-panel-description>
                                                                </mat-expansion-panel-header>
                                                            </mat-expansion-panel>
                                                        </mat-accordion>
                                                    </div>
                                                </div>
                                            </mat-tab>
                                        </mat-tab-group>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </ng-template>
        </mat-tab>

        <!--list view tab 2-->
        <mat-tab label="List View" *ngIf="dyanmicListView">
            <mat-card fxLayout="row" fxLayoutAlign="end center" class="p-8">
                <div fxFlex="5" *ngIf="localStorage.role_code != 'END'">
                    <button
                        mat-mini-fab
                        color="primary"
                        (click)="openListFilterBox()"
                        matTooltip="Filter Data"
                    >
                        <mat-icon>filter_alt</mat-icon>
                    </button>
                </div>
                <div fxFlex="10">
                    <button
                        mat-mini-fab
                        color="primary"
                        (click)="tableExport()"
                        matTooltip="Excel Download"
                    >
                        <mat-icon>sim_card_download</mat-icon></button
                    >&nbsp;&nbsp;
                    <button
                        mat-mini-fab
                        color="primary"
                        (click)="pdfExport()"
                        matTooltip="PDF Download"
                    >
                        <mat-icon>picture_as_pdf</mat-icon>
                    </button>
                </div>
            </mat-card>

            <div class="filter-box-wrapper" *ngIf="listFilterBox">
                <mat-card
                    class="filter-box p-8"
                    *ngIf="localStorage.role_code != 'END'"
                >
                    <mat-card-header>
                        <mat-card-title class="mb-0">Filter</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div
                            id="forms"
                            class="page-layout simple fullwidth"
                            fxLayout="column"
                        >
                            <form
                                [formGroup]="formCCS"
                                class="mat-card mat-elevation-z4 p-15"
                                fxLayout="column"
                                fxLayoutAlign="start"
                                fxFlex="1 0 auto"
                                name="form"
                                style="padding-bottom: 0px"
                            >
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxLayoutGap="25px"
                                    fxFlex="1 0 auto"
                                >
                                    <mat-form-field
                                        appearance="outline"
                                        fxFlex="50"
                                    >
                                        <mat-label>Select Client</mat-label>
                                        <input
                                            type="text"
                                            matInput
                                            formControlName="charClient"
                                            [matAutocomplete]="autoClient"
                                        />
                                        <mat-autocomplete
                                            #autoClient="matAutocomplete"
                                            [displayWith]="displayCharClient"
                                            (optionSelected)="
                                                onClientChange(
                                                    $event.option.value
                                                        .client_id
                                                )
                                            "
                                        >
                                            <mat-option
                                                *ngFor="
                                                    let option of filteredOptionsCharClient
                                                        | async
                                                "
                                                [value]="option"
                                            >
                                                {{ option.client_name }}
                                            </mat-option>
                                        </mat-autocomplete>
                                        <mat-icon
                                            matSuffix
                                            class="secondary-text"
                                            matTooltip="Please select client"
                                            >expand_more
                                        </mat-icon>
                                        <mat-error
                                            *ngIf="
                                                formCCS.get('charClient')
                                                    .invalid
                                            "
                                        >
                                            Please select client
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field
                                        appearance="outline"
                                        fxFlex="50"
                                    >
                                        <mat-label>Select CPO's</mat-label>
                                        <input
                                            type="text"
                                            matInput
                                            formControlName="charCPO"
                                            [matAutocomplete]="auto1"
                                        />
                                        <mat-autocomplete
                                            #auto1="matAutocomplete"
                                            [displayWith]="displayCharCPO"
                                            (optionSelected)="
                                                onCPOChange(
                                                    $event.option.value.cpo_id
                                                )
                                            "
                                        >
                                            <mat-option
                                                *ngFor="
                                                    let option of filteredOptionsCharCPO
                                                        | async
                                                "
                                                [value]="option"
                                            >
                                                {{ option.cpo_name }}
                                            </mat-option>
                                        </mat-autocomplete>
                                        <mat-icon
                                            matSuffix
                                            class="secondary-text"
                                            matTooltip="Please select CPO"
                                            >expand_more
                                        </mat-icon>
                                        <mat-error
                                            *ngIf="
                                                formCCS.get('charCPO').invalid
                                            "
                                        >
                                            Please select CPO
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxLayoutGap="25px"
                                    fxFlex="1 0 auto"
                                >
                                    <mat-form-field
                                        appearance="outline"
                                        fxFlex="50"
                                    >
                                        <mat-label
                                            >Select Charging Station</mat-label
                                        >
                                        <input
                                            type="text"
                                            matInput
                                            formControlName="charStat"
                                            [matAutocomplete]="auto2"
                                        />
                                        <mat-autocomplete
                                            #auto2="matAutocomplete"
                                            [displayWith]="displayCharStat"
                                            (optionSelected)="
                                                onStationChange(
                                                    $event.option.value
                                                        .station_id
                                                )
                                            "
                                        >
                                            <mat-option
                                                *ngFor="
                                                    let option of filteredOptionsCharStat
                                                        | async
                                                "
                                                [value]="option"
                                            >
                                                {{ option.station_name }}
                                            </mat-option>
                                        </mat-autocomplete>
                                        <mat-icon
                                            matSuffix
                                            class="secondary-text"
                                            matTooltip="Please select charging station"
                                        >
                                            expand_more</mat-icon
                                        >
                                        <mat-error
                                            *ngIf="
                                                formCCS.get('charStat').invalid
                                            "
                                        >
                                            Please select charging station
                                        </mat-error>
                                    </mat-form-field>

                                    <div fxFlex="50"></div>
                                </div>
                            </form>
                        </div>
                    </mat-card-content>
                    <mat-card-footer class="m-0">
                        <div class="p-15">
                            <div fxLayout="row" fxLayoutAlign="end center">
                                <button
                                    mat-raised-button
                                    color="warn"
                                    type="button"
                                    class="mr-8 my-0"
                                    (click)="openListFilterBox()"
                                >
                                    Cancel
                                </button>
                                <!-- <button mat-raised-button type="button" color="warn" class="mr-8" (click)="close()">Cancel</button> -->
                            </div>
                        </div>
                    </mat-card-footer>
                </mat-card>
            </div>

            <div
                fxLayout="row wrap"
                class="page-layout simple fullwidth"
                style="overflow: scroll"
            >
                <div class="content" style="min-width: auto">
                    <div class="mat-elevation-z8">
                        <table
                            mat-table
                            matTableFilter
                            [dataSource]="dataSource"
                            [exampleEntity]="filterEntity"
                            [filterType]="filterType"
                            matSort
                            class="mat-elevation-z8"
                        >
                            <ng-container matColumnDef="cpo_name">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header
                                >
                                    <span
                                        *ngIf="!cpoSearch"
                                        class="custom_font_size"
                                        style="display: flex; width: 300px"
                                        >CPO Name &nbsp;&nbsp;
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'cpoSearch',
                                                    $event
                                                )
                                            "
                                            >search</mat-icon
                                        >
                                    </span>
                                    <mat-form-field
                                        *ngIf="cpoSearch"
                                        appearance="outline"
                                        class="list_input"
                                    >
                                        <input
                                            matInput
                                            placeholder="CPO Name"
                                            [(ngModel)]="filterEntity.cpo_name"
                                        />
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'cpoSearch',
                                                    $event
                                                )
                                            "
                                            >highlight_off</mat-icon
                                        >
                                    </mat-form-field>
                                </th>

                                <td mat-cell *matCellDef="let row">
                                    {{ row.cpo_name }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="code">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header
                                >
                                    <span
                                        *ngIf="!stationSearch"
                                        class="custom_font_size"
                                        style="display: flex; width: 300px"
                                    >
                                        Station Code &nbsp;&nbsp;
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'stationSearch',
                                                    $event
                                                )
                                            "
                                            >search
                                        </mat-icon>
                                    </span>
                                    <mat-form-field
                                        *ngIf="stationSearch"
                                        appearance="outline"
                                        class="list_input"
                                    >
                                        <input
                                            matInput
                                            placeholder="Station code"
                                            [(ngModel)]="filterEntity.code"
                                        />
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'stationSearch',
                                                    $event
                                                )
                                            "
                                            >highlight_off</mat-icon
                                        >
                                    </mat-form-field>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    {{ row.code }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="name">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header
                                >
                                    <span
                                        *ngIf="!nameSearch"
                                        class="custom_font_size"
                                        style="display: flex; width: 300px"
                                    >
                                        Name &nbsp;&nbsp;
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'nameSearch',
                                                    $event
                                                )
                                            "
                                            >search</mat-icon
                                        >
                                    </span>
                                    <mat-form-field
                                        *ngIf="nameSearch"
                                        appearance="outline"
                                        class="list_input"
                                    >
                                        <input
                                            matInput
                                            placeholder=" Name"
                                            [(ngModel)]="filterEntity.name"
                                        />
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'nameSearch',
                                                    $event
                                                )
                                            "
                                            >highlight_off</mat-icon
                                        >
                                    </mat-form-field>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    {{ row.name }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="cp_name">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header
                                >
                                    <span
                                        *ngIf="!cpSearch"
                                        class="custom_font_size"
                                        style="display: flex; width: 300px"
                                    >
                                        Contact Person &nbsp;&nbsp;
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'cpSearch',
                                                    $event
                                                )
                                            "
                                            >search</mat-icon
                                        >
                                    </span>
                                    <mat-form-field
                                        *ngIf="cpSearch"
                                        appearance="outline"
                                        class="list_input"
                                    >
                                        <input
                                            matInput
                                            placeholder=" Contact Person "
                                            [(ngModel)]="filterEntity.cp_name"
                                        />
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'cpSearch',
                                                    $event
                                                )
                                            "
                                            >highlight_off</mat-icon
                                        >
                                    </mat-form-field>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    {{ row.cp_name }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="mobile">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header
                                >
                                    <span
                                        *ngIf="!mobileSearch"
                                        class="custom_font_size"
                                        style="display: flex; width: 300px"
                                    >
                                        Mobile &nbsp;&nbsp;
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'mobileSearch',
                                                    $event
                                                )
                                            "
                                            >search</mat-icon
                                        >
                                    </span>
                                    <mat-form-field
                                        *ngIf="mobileSearch"
                                        appearance="outline"
                                        class="list_input"
                                    >
                                        <input
                                            matInput
                                            placeholder=" Mobile"
                                            [(ngModel)]="filterEntity.mobile"
                                        />
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'mobileSearch',
                                                    $event
                                                )
                                            "
                                            >highlight_off</mat-icon
                                        >
                                    </mat-form-field>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    {{ row.mobile }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="email">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header
                                >
                                    <span
                                        *ngIf="!emailSearch"
                                        class="custom_font_size"
                                        style="display: flex; width: 300px"
                                    >
                                        Email &nbsp;&nbsp;
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'emailSearch',
                                                    $event
                                                )
                                            "
                                            >search</mat-icon
                                        >
                                    </span>
                                    <mat-form-field
                                        *ngIf="emailSearch"
                                        appearance="outline"
                                        class="list_input"
                                    >
                                        <input
                                            matInput
                                            placeholder=" Email"
                                            [(ngModel)]="filterEntity.email"
                                        />
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'emailSearch',
                                                    $event
                                                )
                                            "
                                            >highlight_off</mat-icon
                                        >
                                    </mat-form-field>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    {{ row.email }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="address">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header
                                >
                                    <span
                                        *ngIf="!addressSearch"
                                        class="custom_font_size"
                                        style="display: flex; width: 300px"
                                    >
                                        Address &nbsp;&nbsp;
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'addressSearch',
                                                    $event
                                                )
                                            "
                                            >search</mat-icon
                                        >
                                    </span>
                                    <mat-form-field
                                        *ngIf="addressSearch"
                                        appearance="outline"
                                        class="list_input"
                                    >
                                        <input
                                            matInput
                                            placeholder=" Address"
                                            [(ngModel)]="filterEntity.address1"
                                        />
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'addressSearch',
                                                    $event
                                                )
                                            "
                                            >highlight_off</mat-icon
                                        >
                                    </mat-form-field>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    {{ row.address1 }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="status">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header
                                >
                                    <span
                                        *ngIf="!statusSearch"
                                        class="custom_font_size"
                                        style="display: flex; width: 300px"
                                    >
                                        Status &nbsp;&nbsp;
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'statusSearch',
                                                    $event
                                                )
                                            "
                                            >search</mat-icon
                                        >
                                    </span>
                                    <mat-form-field
                                        *ngIf="statusSearch"
                                        appearance="outline"
                                        class="list_input"
                                    >
                                        <input
                                            matInput
                                            placeholder=" Status"
                                            [(ngModel)]="
                                                filterEntity.statusString
                                            "
                                        />
                                        <mat-icon
                                            matSuffix
                                            (click)="
                                                changeVisibility(
                                                    'statusSearch',
                                                    $event
                                                )
                                            "
                                            >highlight_off</mat-icon
                                        >
                                    </mat-form-field>
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let row"
                                    [style.color]="
                                        row.status == 'Y' ? 'green' : 'red'
                                    "
                                >
                                    {{
                                        row.status == "Y"
                                            ? "Active"
                                            : "Inactive"
                                    }}
                                </td>
                            </ng-container>

                            <!-- Action Column -->
                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef>
                                    <span
                                        class="custom_font_size"
                                        style="padding-right: 10px !important"
                                        >Action</span
                                    >
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-icon
                                        color="primary"
                                        matTooltip="View details"
                                        (click)="viewDetails(element)"
                                        style="cursor: pointer"
                                        >preview</mat-icon
                                    >

                                    <!-- <button mat-raised-button color="primary" (click)="viewDetails(element)">
                view details</button> -->
                                </td>
                            </ng-container>

                            <tr
                                mat-header-row
                                *matHeaderRowDef="displayedColumns"
                            ></tr>
                            <tr
                                mat-row
                                *matRowDef="let row; columns: displayedColumns"
                            ></tr>
                        </table>
                        <mat-paginator
                            #paginator
                            [pageSizeOptions]="[20, 30, 50, 100]"
                        ></mat-paginator>
                    </div>
                </div>
            </div>
        </mat-tab>

        <!--list view tab 3-->
        <mat-tab label="CPO Consumption" *ngIf="dyanmicCpoConsumListView">
            <mat-card class="ledger-card">
                <div class="ledger-header" style="display:flex; justify-content:space-between; align-items:center;">
                    <p class="date-text">
                        <strong>Start Date:</strong> {{ startDate }} |
                        <strong>End Date:</strong> {{ endDate }}
                    </p>
                    <div class="action-buttons" style="display:flex; gap:10px;" *ngIf="localStorage.role_code != 'END'">
                        <button
                            mat-mini-fab
                            color="primary"
                            (click)="openListFilterBox2()"
                            matTooltip="Filter Data"
                        >
                            <mat-icon>filter_alt</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-card>

            <div class="filter-box-wrapper" *ngIf="listFilterBox2">
                <mat-card class="filter-box p-8">
                    <mat-card-header>
                        <mat-card-title class="mb-0">Filter</mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <form [formGroup]="formCCS2">
                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>Select Date Range</mat-label>

                                <mat-date-range-input
                                    [rangePicker]="rangePicker"
                                    [formGroup]="formCCS2"
                                >
                                    <input
                                        matStartDate
                                        formControlName="startDate"
                                        placeholder="Start date"
                                    />

                                    <input
                                        matEndDate
                                        formControlName="endDate"
                                        placeholder="End date"
                                    />
                                </mat-date-range-input>

                                <mat-datepicker-toggle
                                    matSuffix
                                    [for]="rangePicker"
                                >
                                </mat-datepicker-toggle>

                                <mat-date-range-picker
                                    #rangePicker
                                ></mat-date-range-picker>
                            </mat-form-field>
                        </form>
                    </mat-card-content>

                    <mat-card-footer class="m-0">
                        <div
                            class="p-15"
                            fxLayout="row"
                            fxLayoutAlign="end center"
                            fxLayoutGap="10px"
                        >
                            <button
                                mat-raised-button
                                color="primary"
                                (click)="applyFilter2()"
                            >
                                Apply
                            </button>

                            <button
                                mat-raised-button
                                color="warn"
                                (click)="openListFilterBox2()"
                            >
                                Cancel
                            </button>
                        </div>
                    </mat-card-footer>
                </mat-card>
            </div>

            <div
                fxLayout="row wrap"
                class="page-layout simple fullwidth"
                style="overflow: scroll"
            >
                <div class="content" style="min-width: auto">
                    <div class="cpo-grid">
                        <div
                            class="cpo-card"
                            *ngFor="let cpo of cpoCunsumDataSource"
                            [class.zero]="cpo.total_consumption === 0"
                        >
                            <div class="cpo-header">
                                {{ cpo.cpo_name }}
                            </div>

                            <div class="cpo-body">
                                <div class="summary-row">
                                    <span>Total Consumption</span>
                                    <span
                                        class="summary-badge consumption-badge"
                                    >
                                        {{
                                            cpo.total_consumption / 1000
                                                | number : "1.2-2"
                                        }}
                                        kWh
                                    </span>
                                </div>

                                <div class="summary-row">
                                    <span>Tota Available Balance</span>
                                    <span class="summary-badge amount-badge">
                                        ₹
                                        {{
                                            cpo.total_billed_amt
                                                | number : "1.2-2"
                                        }}
                                    </span>
                                </div>

                                <div class="recharge-summary">
                                    <div class="recharge-card">
                                        <div class="title">Total Recharge(MTD)</div>
                                        <div class="amount">
                                            ₹ {{ cpo.total_recharge_amt | number : "1.2-2" }}
                                        </div>
                                    </div>

                                    <div class="recharge-card till-date">
                                        <div class="title">Total Recharge(YTD)</div>
                                        <div class="amount">
                                            ₹ {{ cpo.total_recharge_till_date | number : "1.2-2" }}
                                        </div>
                                    </div>
                                </div>

                                <div class="station-list">
                                    <div
                                        class="station-item"
                                        *ngFor="let station of cpo.stations"
                                    >
                                        <div class="station-name">
                                            {{ station.station_name }}
                                        </div>

                                        <div class="station-info">
                                            <span class="station-consumption">
                                                ⚡
                                                {{
                                                    station.consumption / 1000
                                                        | number : "1.2-2"
                                                }}
                                                kWh
                                            </span>
                                            <span class="station-amount">
                                                ₹
                                                {{
                                                    station.billed_amt
                                                        | number : "1.2-2"
                                                }} (Billed AMT)
                                            </span>
                                        </div>
                                        <div class="recharge-box">
                                            <div class="recharge-item">
                                                <div class="label">Total Recharge(MTD)</div>
                                                <div class="value">
                                                    ₹ {{ station.recharge_amt | number : "1.2-2" }}
                                                </div>
                                            </div>

                                            <div class="recharge-item">
                                                <div class="label">Total Recharge(YTD)</div>
                                                <div class="value">
                                                    ₹ {{ station.total_recharge_till_date | number : "1.2-2" }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>

        <!--list view tab 4-->
        <mat-tab label="CPO Leadger" *ngIf="dyanmicCpoStationConsumListView">
            <mat-card class="ledger-card">
                <div class="ledger-header" style="display: flex;justify-content: space-between;">

                    <p class="date-text">
                        <strong>Start Date:</strong> {{ startDate }} |
                        <strong>End Date:</strong> {{ endDate }}
                    </p>

                    <div class="action-buttons" style="display: flex;gap: 10px;" *ngIf="localStorage.role_code != 'END'">

                        <button
                            mat-mini-fab
                            color="primary"
                            (click)="openListFilterBox3()"
                            matTooltip="Filter Data"
                        >
                            <mat-icon>filter_alt</mat-icon>
                        </button>

                        <button
                            mat-mini-fab
                            color="primary"
                            (click)="tableExport2()"
                            matTooltip="Excel Download"
                        >
                            <mat-icon>sim_card_download</mat-icon>
                        </button>

                        <button
                            mat-mini-fab
                            color="primary"
                            (click)="pdfExport2()"
                            matTooltip="PDF Download"
                        >
                            <mat-icon>picture_as_pdf</mat-icon>
                        </button>

                    </div>

                </div>
            </mat-card>

            <div class="filter-box-wrapper" *ngIf="listFilterBox3">
                <mat-card class="filter-box p-8">
                    <mat-card-header>
                        <mat-card-title class="mb-0">Filter</mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <form [formGroup]="formCCS3">
                            <div
                                fxLayout="row"
                                fxLayoutAlign="start center"
                                fxLayoutGap="25px"
                                fxFlex="1 0 auto"
                            >
                                <mat-form-field
                                    appearance="outline"
                                    fxFlex="50"
                                >
                                    <mat-label>Select Client</mat-label>
                                    <input
                                        type="text"
                                        matInput
                                        formControlName="charClient"
                                        [matAutocomplete]="autoClient"
                                    />
                                    <mat-autocomplete
                                        #autoClient="matAutocomplete"
                                        [displayWith]="displayCharClient"
                                        (optionSelected)="
                                            onClientChange(
                                                $event.option.value
                                                    .client_id
                                            )
                                        "
                                    >
                                        <mat-option
                                            *ngFor="
                                                let option of filteredOptionsCharClient
                                                    | async
                                            "
                                            [value]="option"
                                        >
                                            {{ option.client_name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-icon
                                        matSuffix
                                        class="secondary-text"
                                        matTooltip="Please select client"
                                        >expand_more
                                    </mat-icon>
                                    <mat-error
                                        *ngIf="
                                            formCCS3.get('charClient')
                                                .invalid
                                        "
                                    >
                                        Please select client
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    fxFlex="50"
                                >
                                    <mat-label>Select CPO's</mat-label>
                                    <input
                                        type="text"
                                        matInput
                                        formControlName="charCPO"
                                        [matAutocomplete]="auto1"
                                    />
                                    <mat-autocomplete
                                        #auto1="matAutocomplete"
                                        [displayWith]="displayCharCPO"
                                        (optionSelected)="
                                            onCPOChange(
                                                $event.option.value.cpo_id
                                            )
                                        "
                                    >
                                        <mat-option
                                            *ngFor="
                                                let option of filteredOptionsCharCPO
                                                    | async
                                            "
                                            [value]="option"
                                        >
                                            {{ option.cpo_name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-icon
                                        matSuffix
                                        class="secondary-text"
                                        matTooltip="Please select CPO"
                                        >expand_more
                                    </mat-icon>
                                    <mat-error
                                        *ngIf="
                                            formCCS3.get('charCPO').invalid
                                        "
                                    >
                                        Please select CPO
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div
                                fxLayout="row"
                                fxLayoutAlign="start center"
                                fxLayoutGap="25px"
                                fxFlex="1 0 auto"
                            >
                                <mat-form-field
                                    appearance="outline"
                                    fxFlex="50"
                                >
                                    <mat-label
                                        >Select Charging Station</mat-label
                                    >
                                    <input
                                        type="text"
                                        matInput
                                        formControlName="charStat"
                                        [matAutocomplete]="auto2"
                                    />
                                    <mat-autocomplete
                                        #auto2="matAutocomplete"
                                        [displayWith]="displayCharStat"
                                        (optionSelected)="
                                            onStationChange(
                                                $event.option.value
                                                    .station_id
                                            )
                                        "
                                    >
                                        <mat-option
                                            *ngFor="
                                                let option of filteredOptionsCharStat
                                                    | async
                                            "
                                            [value]="option"
                                        >
                                            {{ option.station_name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-icon
                                        matSuffix
                                        class="secondary-text"
                                        matTooltip="Please select charging station"
                                    >
                                        expand_more</mat-icon
                                    >
                                    <mat-error
                                        *ngIf="
                                            formCCS3.get('charStat').invalid
                                        "
                                    >
                                        Please select charging station
                                    </mat-error>
                                </mat-form-field>

                                <div fxFlex="50"></div>
                            </div>
                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>Select Date Range</mat-label>

                                <mat-date-range-input
                                    [rangePicker]="rangePicker"
                                    [formGroup]="formCCS3"
                                >
                                    <input
                                        matStartDate
                                        formControlName="startDate"
                                        placeholder="Start date"
                                    />

                                    <input
                                        matEndDate
                                        formControlName="endDate"
                                        placeholder="End date"
                                    />
                                </mat-date-range-input>

                                <mat-datepicker-toggle
                                    matSuffix
                                    [for]="rangePicker"
                                >
                                </mat-datepicker-toggle>

                                <mat-date-range-picker
                                    #rangePicker
                                ></mat-date-range-picker>
                            </mat-form-field>
                        </form>
                    </mat-card-content>

                    <mat-card-footer class="m-0">
                        <div
                            class="p-15"
                            fxLayout="row"
                            fxLayoutAlign="end center"
                            fxLayoutGap="10px"
                        >
                            <button
                                mat-raised-button
                                color="primary"
                                (click)="applyFilter3()"
                            >
                                Apply
                            </button>

                            <button
                                mat-raised-button
                                color="warn"
                                (click)="openListFilterBox3()"
                            >
                                Cancel
                            </button>
                        </div>
                    </mat-card-footer>
                </mat-card>
            </div>

            <div class="ledger-main">
                <div class="table-box">
                    <table class="premium-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>CPO</th>
                                <th>Station</th>
                                <th>User</th>
                                <th>User Id</th>
                                <th>Energy</th>
                                <th>Charger</th>
                                <th>Connector</th>
                                <th>Debit Amt</th>
                                <th>Credit Amt</th>
                                <th>Transaction Date</th>
                                <th>Balance</th>
                                <th>Payment Status</th>
                                <th>Payment Mode</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr *ngFor="let tx of ledgerRows; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ tx.cpo_name }}</td>
                                <td>{{ tx.station_name }}</td>
                                <td>{{ tx.user_name || 'Unknown' }}</td>
                                <td>{{ tx.user_id }}</td>
                                <td class="energy">{{ tx.energy_consumed ? (tx.energy_consumed / 1000 | number:'1.2-2') + ' kWh' : '' }}</td>
                                <td>{{ tx.charger_display_id }}</td>
                                <td>{{ tx.connector_no }}</td>
                                <td class="amount">{{ tx.debit_amount ? '₹' + tx.debit_amount : '' }}</td>
                                <td class="energy">{{ tx.credit_amount ? '₹' + tx.credit_amount : '' }}</td>
                                <td>{{ tx.transaction_date }}</td>
                                <td>{{ tx.balance ? '₹' + tx.balance : '' }}</td>
                                <td>{{ tx.payment_status }}</td>
                                <td>{{ tx.payment_mode }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
